"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _default = {
  title: 'Slider Thumbnails',
  isRelevant: function isRelevant(styleParams) {
    return styleParams.oneRow;
  },
  type: _constants.INPUT_TYPES.BOOLEAN,
  "default": false,
  description: "Choose if you want to have slider thumbnails in the gallery. Note that this option is relevant only\n  to galleries that render the slideShowView component.\n  "
};
exports["default"] = _default;